export class AnalyticsService {
    static logEvent(eventName) {
        // Disable
    }
}

export class AnalyticsEventName {
    static openedFrom = 'opened_from'
}